import { CurrencyInput } from '@popsure/dirty-swan';
import {
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '../../../models';
import { useEffect, useState } from 'react';
import { Header } from '../../Screen';

export type CurrencyInputFormProps<
  Questionnaire extends QuestionnaireQuestions
> = {
  validate?: (value?: number) => boolean;
} & QuestionnaireFormProps<Questionnaire, number>;

export const CurrencyInputForm = <
  Questionnaire extends QuestionnaireQuestions
>({
  onSubmitValue,
  value,
  question,
  hideLabel,
  label,
  placeholder,
  featureName,
  validate,
  setValidForSubmission,
}: CurrencyInputFormProps<Questionnaire>) => {
  const [currency, setCurrency] = useState<number | undefined>(value);

  const handleSubmit = () => {
    if (typeof currency === 'undefined') {
      throw new Error(
        `[${featureName}] Currency value is missing for submission for question: ${question}`
      );
    }
    onSubmitValue(currency);
  };

  useEffect(() => {
    const validInput = validate ? validate(currency) : currency;
    setValidForSubmission(Boolean(validInput));
  }, [currency, setValidForSubmission, validate]);

  return (
    <Header onSubmit={handleSubmit}>
      <CurrencyInput
        placeholder={placeholder}
        label={label}
        hideLabel={hideLabel}
        value={currency}
        onChange={setCurrency}
        data-cy="input"
      />
    </Header>
  );
};
